import React, { useEffect, useState } from "react";
import { FaCircleInfo, FaGithub, FaInfo, FaXTwitter } from "react-icons/fa6";
import { IoInformationCircleOutline } from "react-icons/io5";
import { AnimatePresence, motion } from "framer-motion";

const Header = () => {
  const [isInfoDialogOpen, setInfoDialogOpen] = useState(false);

  return (
    <>
      <div className="w-full fixed top-0 left-0 right-0 p-2 flex items-center justify-center z-50">
        <div
          className="border border-black/20 p-1 gap-6 flex items-center justify-between rounded-xl bg-white/40 backdrop-blur-lg"
          style={{
            boxShadow:
              "0 5px 10px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255 255 255 / 0.3)",
          }}
        >
          <div className="flex items-center">
            <a href="/">
              <img src="/dynamic-island.png" className="h-8 w-8" />
            </a>
          </div>
          <div className="flex items-center">
            <button
              className="h-8 w-8 flex items-center justify-center rounded-lg hover:bg-gray-800 hover:text-white"
              onClick={() => setInfoDialogOpen(true)}
            >
              <IoInformationCircleOutline size={20} />
            </button>
            <div className="w-0 h-4 border-l border-l-black/40 mx-1"></div>
            <a
              className="h-8 w-8 flex items-center justify-center rounded-lg hover:bg-gray-800 hover:text-white"
              href="https://twitter.com/Satyam_Mis"
              target="_blank"
              rel="noreferrer"
            >
              <FaXTwitter />
            </a>
            <a
              className="h-8 w-8 flex items-center justify-center rounded-lg hover:bg-gray-800 hover:text-white"
              href="https://github.com/satyam-mishra-pce/dynamic-island"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {isInfoDialogOpen && (
          <motion.div
            className="w-full fixed top-0 bottom-0 left-0 right-0 flex items-start justify-center z-50 bg-black/50 p-4 overflow-y-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setInfoDialogOpen(false)}
          >
            <motion.div
              onClick={(evt) => {
                evt.stopPropagation();
              }}
              className="border border-black/20 flex flex-col items-center justify-between rounded-3xl bg-white/60 text-[#111111] backdrop-blur-lg overflow-hidden w-full max-w-sm my-auto"
              style={{
                boxShadow:
                  "0 5px 10px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255 255 255 / 0.3)",
              }}
              initial={{
                scale: 1.5,
                opacity: 0,
                filter: "blur(10px)",
              }}
              animate={{
                scale: 1,
                opacity: 1,
                filter: "blur(0px)",
              }}
              exit={{
                scale: 0.9,
                opacity: 0,
                filter: "blur(10px)",
              }}
            >
              <div className="w-full bg-gray-200 flex flex-col items-center justify-center p-4 text-black">
                <img
                  src="/dynamic-island.png"
                  className="h-20 w-20 drop-shadow-lg mb-4"
                />
                <h1 className="font-bold text-xl">Dynamic Island</h1>
                <span className="text-gray-800 font-medium">v0.1</span>
              </div>
              <div className="w-full p-4 flex flex-col gap-4">
                <div className="w-full">
                  <strong>About</strong>
                  <p className="font-medium leading-5 text-justify text-pretty">
                    This is the Dynamic Island for the web. You can use this app
                    to experience the dynamic island of iOS in your web browser.
                    The page imitates the experience with an accuracy of more
                    than 90%. This tool is built using ReactJS and motion.dev
                    (formerly, framer motion).
                  </p>
                </div>
                <div className="w-full">
                  <strong>How to use?</strong>
                  <p className="font-medium leading-5 text-justify text-pretty">
                    Using it is very simple. To start, you can tap any of the
                    widgets in the phone, and then you can follow the
                    instructions on the widget itself to play with the dynamic
                    island. Moreover, you can tap the notch, when an app is
                    running to open the maximized view and swipe up on it to
                    minimize it back.
                  </p>
                </div>
                <div className="w-full">
                  <strong>Credits</strong>
                  <p className="font-medium leading-5 text-justify text-pretty">
                    Made by{" "}
                    <a
                      href="https://github.com/satyam-mishra-pce"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b>Satyam Mishra.</b>
                    </a>
                  </p>
                </div>
              </div>
              <div className="w-full flex flex-col items-center justify-center p-2">
                <button
                  className="w-full bg-blue-600 rounded-2xl h-10 text-white text-lg border border-black/30 hover:brightness-105 active:brightness-95"
                  style={{
                    boxShadow:
                      "0 5px 10px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255 255 255 / 0.2)",
                  }}
                  onClick={() => setInfoDialogOpen(false)}
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
